import { Card, FormControlLabel, Stack, Switch, Typography, styled } from '@mui/material';

import { Spinner } from '../../../components/spinners';
import { ErrorMessages, RegistrationStrings } from '../../../constants';
import {
  useGetRegistrationSettings,
  useUpdateRegistrationSettings,
} from '../../../lib/registration/hooks';

function RegistrationModule() {
  const { data: settings, isError, isLoading } = useGetRegistrationSettings();
  const { mutate: updateSettings, isLoading: isUpdating } =
    useUpdateRegistrationSettings();

  return (
    <Container>
      <Typography variant="h5">{RegistrationStrings.TITLE}</Typography>
      <StyledCard>
        {isLoading ? (
          <Spinner />
        ) : isError ? (
          <Typography color="error">{ErrorMessages.SERVER_ERROR}</Typography>
        ) : (
          <Stack spacing={1}>
            <FormControlLabel
              control={
                <Switch
                  checked={settings?.publicRegistrationEnabled ?? false}
                  disabled={isUpdating}
                  onChange={(_event, checked) => updateSettings(checked)}
                />
              }
              label={RegistrationStrings.PUBLIC_REGISTRATION_ENABLED}
            />
            <Typography variant="body2">
              {RegistrationStrings.DESCRIPTION}
            </Typography>
          </Stack>
        )}
      </StyledCard>
    </Container>
  );
}

const Container = styled('div')({
  padding: '20px',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
});

const StyledCard = styled(Card)({
  padding: '24px',
});

export default RegistrationModule;
